import { render, staticRenderFns } from "./WorkFlow.vue?vue&type=template&id=1d54d242&scoped=true&"
import script from "./WorkFlow.vue?vue&type=script&lang=js&"
export * from "./WorkFlow.vue?vue&type=script&lang=js&"
import style0 from "./WorkFlow.vue?vue&type=style&index=0&id=1d54d242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d54d242",
  null
  
)

export default component.exports